import api from "./api";
import { resources } from "./resources";
import { ToQueryString } from "../utils/utils";
class SincronizacaoService {
    async Synchronize(updateDate: any) {
        return await api.get(`${resources.sincronizacao}/Synchronize/${ToQueryString(updateDate)}`);
    }

    async getStatus() {
        return await api.get(`${resources.sincronizacao}/GetStatus`);
    }
}

export default new SincronizacaoService();
